import logActions from 'actions/logActions';
import Storage from 'utilities/storage';
import { PUBLICA_URL, ALLOW_COOKIE } from 'constants/index';

export const deleteCookie = () => {
    if (Storage.cookies.get('accessToken')) {
        Storage.cookies.remove('accessToken');
    }

    if (Storage.cookies.get('refreshToken')) {
        Storage.cookies.remove('refreshToken');
    }

    if (Storage.cookies.get('openBankToken')) {
        Storage.cookies.remove('openBankToken');
    }

    if (Storage.cookies.get('RASuitabilityStarted')) {
        Storage.cookies.remove('RASuitabilityStarted');
    }
};

export const deleteCookieAndGoHome = () => {
    deleteCookie();
    window.location.href = PUBLICA_URL;
};

export const logoutUser = (dispatch, userProfile) => {
    let accessToken;
    if (typeof userProfile.accessToken !== 'undefined') {
        accessToken = userProfile.accessToken;

        dispatch(logActions.logout(accessToken));
    } else if (ALLOW_COOKIE && Storage.cookies.get('accessToken')) {
        accessToken = Storage.cookies.get('accessToken');
        dispatch(logActions.logout(accessToken));
    }
};
